import { httpClient } from '@/services/http/httpClient';
import type {
  CompetitorAccount,
  AddCompetitorDto,
  UpdateCompetitorDto,
  CompetitorPostsParams,
  PaginatedCompetitorPosts,
  CompetitorInsights,
} from '@/types';

export const competitorApi = {
  /** POST /api/competitor-listening/accounts — add a competitor to track */
  async addCompetitor(data: AddCompetitorDto) {
    return httpClient.post<CompetitorAccount>('/competitor-listening/accounts', data);
  },

  /** GET /api/competitor-listening/accounts — list tracked competitors */
  async listCompetitors() {
    return httpClient.get<CompetitorAccount[]>('/competitor-listening/accounts');
  },

  /** PATCH /api/competitor-listening/accounts/:id — update a competitor */
  async updateCompetitor(id: string, data: UpdateCompetitorDto) {
    return httpClient.patch<CompetitorAccount>(`/competitor-listening/accounts/${id}`, data);
  },

  /** DELETE /api/competitor-listening/accounts/:id — remove a competitor */
  async removeCompetitor(id: string) {
    return httpClient.delete<void>(`/competitor-listening/accounts/${id}`);
  },

  /** GET /api/competitor-listening/posts — get competitor posts (paginated) */
  async getPosts(params?: CompetitorPostsParams) {
    return httpClient.get<PaginatedCompetitorPosts>('/competitor-listening/posts', { params });
  },

  /** GET /api/competitor-listening/insights — aggregated insights */
  async getInsights() {
    return httpClient.get<CompetitorInsights>('/competitor-listening/insights');
  },
};
